<template>
  <div class="calendar-svg-loader d-flex flex-column align-center justify-center py-12">
    <svg width="130" height="140" viewBox="0 0 130 140" fill="none" xmlns="http://www.w3.org/2000/svg">
      <!-- Binding posts -->
      <rect x="37" y="8" width="11" height="26" rx="5.5" fill="#5C6BC0"/>
      <rect x="82" y="8" width="11" height="26" rx="5.5" fill="#5C6BC0"/>
      <!-- Calendar body -->
      <rect x="8" y="22" width="114" height="106" rx="9" fill="#F3F4FE" stroke="#5C6BC0" stroke-width="2.5"/>
      <!-- Header bar -->
      <rect x="8" y="22" width="114" height="30" rx="9" fill="#5C6BC0"/>
      <rect x="8" y="40" width="114" height="12" fill="#5C6BC0"/>

      <!-- Day cells: 5 columns × 3 rows, staggered wave animation -->
      <!-- Row 1 -->
      <rect class="cal-cell" x="18" y="66" width="16" height="13" rx="3" fill="#5C6BC0" style="--d:0"/>
      <rect class="cal-cell" x="38" y="66" width="16" height="13" rx="3" fill="#5C6BC0" style="--d:1"/>
      <rect class="cal-cell" x="58" y="66" width="16" height="13" rx="3" fill="#5C6BC0" style="--d:2"/>
      <rect class="cal-cell" x="78" y="66" width="16" height="13" rx="3" fill="#5C6BC0" style="--d:3"/>
      <rect class="cal-cell" x="98" y="66" width="16" height="13" rx="3" fill="#5C6BC0" style="--d:4"/>
      <!-- Row 2 -->
      <rect class="cal-cell" x="18" y="85" width="16" height="13" rx="3" fill="#5C6BC0" style="--d:5"/>
      <rect class="cal-cell" x="38" y="85" width="16" height="13" rx="3" fill="#5C6BC0" style="--d:6"/>
      <rect class="cal-cell" x="58" y="85" width="16" height="13" rx="3" fill="#5C6BC0" style="--d:7"/>
      <rect class="cal-cell" x="78" y="85" width="16" height="13" rx="3" fill="#5C6BC0" style="--d:8"/>
      <rect class="cal-cell" x="98" y="85" width="16" height="13" rx="3" fill="#5C6BC0" style="--d:9"/>
      <!-- Row 3 -->
      <rect class="cal-cell" x="18" y="104" width="16" height="13" rx="3" fill="#5C6BC0" style="--d:10"/>
      <rect class="cal-cell" x="38" y="104" width="16" height="13" rx="3" fill="#5C6BC0" style="--d:11"/>
      <rect class="cal-cell" x="58" y="104" width="16" height="13" rx="3" fill="#5C6BC0" style="--d:12"/>
      <rect class="cal-cell" x="78" y="104" width="16" height="13" rx="3" fill="#5C6BC0" style="--d:13"/>
      <rect class="cal-cell" x="98" y="104" width="16" height="13" rx="3" fill="#5C6BC0" style="--d:14"/>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'CalendarSvgLoader',
};
</script>

<style scoped>
.cal-cell {
  opacity: 0.15;
  animation: calCellPulse 1.6s ease-in-out infinite;
  animation-delay: calc(var(--d) * 0.09s);
}

@keyframes calCellPulse {
  0%, 100% { opacity: 0.15; }
  50% { opacity: 0.85; }
}
</style>
